import React from "react";
import {Box, Chip, CircleDot, Colors} from "@bounce/shared/ui";
import {TriggerInteractionType, TriggerStatus} from "../../apis/requests/triggers/types";
import {TRIGGER_STATUS_DISPLAY} from "./triggerDisplay";

export const CodeChip = ({children}: {children: string}) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      height: 22,
      px: 1,
      borderRadius: "6px",
      backgroundColor: Colors.blue._100,
      color: Colors.blue._900,
      fontSize: 12,
      fontWeight: 500,
      fontFamily: "monospace",
    }}
  >
    {children}
  </Box>
);

export const InteractionChip = ({interactionType}: {interactionType: TriggerInteractionType}) => (
  <CodeChip>{interactionType}</CodeChip>
);

export const TriggerStatusChip = ({status}: {status: TriggerStatus}) => {
  const display = TRIGGER_STATUS_DISPLAY[status];
  return (
    <Chip
      size_="small"
      variant_={display.variant}
      label={display.label}
      icon={<CircleDot size={7} color={display.dotColor} sx={{marginLeft: "2px", marginRight: "-2px"}} />}
      sx={{"& .MuiChip-label": {paddingLeft: "6px", paddingRight: "2px"}}}
    />
  );
};
